/* eslint-disable no-unused-vars */
import { action } from 'typesafe-actions';
import { ActionCreator, Action } from 'redux';
import { IWorkflow } from './workflows';
import { types } from './workflows.types';

const getSelectedWorkflow: ActionCreator<Action<string>> = (payload: IWorkflow) => action(types.GET_SELECTED_WORKFLOW_SUCCESS, payload);

export { getSelectedWorkflow };
